import { ReactNode } from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import { CompanyDocumentTreeDataNode } from "../model/types";
import { useCompanyDocumentTreeDndState } from "../model/company-document-tree-dnd-context";

/**
 * Строка дерева — одновременно то, что тянут, и то, на что бросают. Состояние
 * отдаётся data-атрибутами: подсветку вешает стиль дерева на всю строку antd,
 * до которой отсюда не дотянуться.
 */
export function TreeNodeDnd({
  node,
  draggable,
  children,
}: {
  node: CompanyDocumentTreeDataNode;
  draggable: boolean;
  children: ReactNode;
}) {
  const { dropTargetKey, moving } = useCompanyDocumentTreeDndState();
  const {
    attributes,
    listeners,
    setNodeRef: setDraggableRef,
    isDragging,
  } = useDraggable({
    id: node.key,
    data: { node },
    disabled: !draggable || moving,
  });
  const { setNodeRef: setDroppableRef } = useDroppable({ id: node.key });

  return (
    <span
      ref={(element) => {
        setDraggableRef(element);
        setDroppableRef(element);
      }}
      className="block w-full min-w-0"
      data-dragging={isDragging || undefined}
      data-drop-target={dropTargetKey === node.key || undefined}
      {...listeners}
      {...attributes}
      // dnd-kit делает обёртку кнопкой и забирает фокус у строки antd-дерева.
      role={undefined}
      tabIndex={undefined}
    >
      {children}
    </span>
  );
}
